import React from 'react';
import { FiltersState } from 'src/domains/layouts/webview/components/filters/Filters.state';
import { FiltersSecondaryWrapper } from 'src/domains/layouts/webview/components/filtersSecondary/FiltersSecondary.style';
import { observer } from 'src/utils/mobx-react';
import { UnifiedSportEventsListState } from 'src/domains/sportsbook/state/eventsListState/unifiedSportEventsListState/UnifiedSportEventsListState';
import { MatchType } from 'src/domains/sportsbook/state/eventsListState/unifiedSportEventsListState/markets';
import { SportsFilterChipType } from './UnifiedSportsFilters.state';
import { SportsTimeFilterType } from './SportsTimeFilter';
import { SportsFiltersUnifiedMarketRow } from './SportsFiltersUnifiedMarketRow';
import { SportsFiltersUnifiedPrimaryRow } from './SportsFiltersUnifiedPrimaryRow';
import { SportsFiltersCompetitionPrimaryRow } from './SportsFiltersCompetitionPrimaryRow';

interface SportsFiltersPropsType {
    eventsListState: UnifiedSportEventsListState;
    sportWideListState: UnifiedSportEventsListState;
    timeFiltersState: FiltersState<SportsTimeFilterType | null>;
    marketFiltersState: FiltersState<MatchType | null>;
    sportFilterChip: SportsFilterChipType;
    onSportFilterChipChange: (chip: SportsFilterChipType) => void;
    isCompetitionPage: boolean;
    showMarketFilters: boolean;
}

export const SportsFilters = observer('SportsFilters', (props: SportsFiltersPropsType) => {
    const {
        eventsListState,
        sportWideListState,
        timeFiltersState,
        marketFiltersState,
        sportFilterChip,
        onSportFilterChipChange,
        isCompetitionPage,
        showMarketFilters,
    } = props;

    const filterContextState = isCompetitionPage === true ? eventsListState : sportWideListState;
    const inPlayCount = filterContextState.inPlayCount;
    const outrightsCount = filterContextState.outrightsCount;

    return (
        <FiltersSecondaryWrapper data-testid='sports-filters'>
            {isCompetitionPage === true ? (
                <SportsFiltersCompetitionPrimaryRow
                    eventsListState={eventsListState}
                    onSportFilterChipChange={onSportFilterChipChange}
                    outrightsCount={outrightsCount}
                />
            ) : (
                <SportsFiltersUnifiedPrimaryRow
                    eventsListState={eventsListState}
                    timeFiltersState={timeFiltersState}
                    sportFilterChip={sportFilterChip}
                    onSportFilterChipChange={onSportFilterChipChange}
                    inPlayCount={inPlayCount}
                    outrightsCount={filterContextState.outrightsCompetitionsCount}
                />
            )}

            {showMarketFilters === true ? (
                <SportsFiltersUnifiedMarketRow
                    eventsListState={eventsListState}
                    marketFiltersState={marketFiltersState}
                />
            ) : null}
        </FiltersSecondaryWrapper>
    );
});
